export default "__VITE_ASSET__CiTc752a__"